import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "store/selector";
import { menu } from "constant/menu";

const PublicRoute = ({ children }) => {
  const { token } = useSelector(getUser);
  const location = useLocation();
  const isCommonRoute = menu.some(
    (item) => item.link === location.pathname && item.isCommonRoute
  );

  if (
    token &&
    (location.pathname === "/login" || location.pathname === "/register") &&
    !isCommonRoute
  ) {
    // Redirect authenticated users to a protected page
    return <Navigate to="/profileedit" replace />;
  }

  // Render the public route if the user is not authenticated
  return children;
};

export default PublicRoute;
